import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { getPageContent } from "../../utils/content/getPageContent";
import { PageContent, pageContent } from "../../config/routes/content";

export const usePageContent = () => {
	const location = useLocation();
	const [currentPageContent, setCurrentPageContent] = useState<PageContent | undefined>();

	useEffect(() => {
		const currentPageContent = getPageContent(pageContent, location.pathname);
		setCurrentPageContent(currentPageContent);
	}, [location.pathname]);

	return {
		blocks: [],
		...currentPageContent,
	} as PageContent;
};
